export default {
  navigationBarTitleText: 'test call App'
};
